import SLS_pedidosVendasService from '@/services/Operacoes/sls_pedidoVendas.service.js';
import Vue from 'vue';

export default {
  namespaced: true,
  state: () => ({
    setIsLoading: false,
    setIsLoadingMarca: false,
    setIsLoadingCategoria: false,
    setIsLoadingReferencia: false,
    setIsLoadingReferenciaRestante: false,
    setIsLoadingEmbalagem: false,
    setIsLoadingCapaPedido: false,
    setIsLoadingCliente: false,
    setIsLoadingimagens: false,
    setIsLoadingPrecoItens: false,
    jsonTelaNovaPedido: [],
    setEsMarcas: [],
    setEsCategorias: [{
      value: null,
      text: 'Selecione uma categoria',
      disabled: true,
    }],
    setEsReferencias: [
      {
        value: null,
        text: 'Selecione uma referência',
        disabled: true,
      },
    ],
    setEsEmbalagens: [
      {
        value: null,
        text: 'Selecione uma embalagem',
        disabled: true,
      },
    ],
    setOptionsTipoPedidoCliente: [
      {
        value: null,
        text: 'Selecione um tipo de pedido',
        disabled: true,
      },
    ],
    setExisteMarca: false,
    setExisteCategoria: false,
    setExisteReferencia: false,
    setExisteEmbalagem: false,
    setFormData: {
      dataCapaPedido: {
        representanteid: '',
        representantenome: '',
        estabelecimentoid: '',
        condicaopagamentoid: '',
        estabelecimentorazaosocial: '',
        clienteiderp: '',
        cliente_nome: '',
        clienteisentoie: '',
        clientenomeabreviado: '',
        naturezaoperacaoid: '',
        naturezaoperacaodescricao: '',
        canal_venda_id: '',
        canal_venda_descricao: '',
        condicaopagamentodescricao: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        nr_oc: '',
        prioridade_pedido: '',
        observacoes: '',
        cdn_embalagem: '',
        des_embalag: '',
        canalvendaid: '',
        tipopedidoid: '',
        tipofrete: '',
        transportadoraid: '',
        transportadoranome: '',
      },
      dataItensPedido: {
        item_id: '',
        item_name: '',
        item_price: '',
        item_descricao: '',
        item_caracteristicas: '',
        item_composisao: '',
        item_indicacoes: '',
        item_img_princial: '',
        item_marca: '',
        cod_marca: '',
        referencia: '',
        gradeItem: [],
        imagens: [],
      },
      enderecoEntrega: {
        clienteid: '',
        tipoenderecoid: '',
        clienteenderecoseq: '',
        clienteiderp: '',
        clienteenderecocep: '',
        clienteendereco: '',
        paisid: '',
        ufid: '',
        clienteenderecoobservacoes: '',
        clienteenderecocidade: '',
        clienteenderecobairro: '',
        clienteiderpenderecoentrega: '',
        clienteenderecoie: '',
        pais_nome: '',
        tipoEnderecoDescricao: '',
        dataPrevistaEntrega: '',
      },
      transportadoraFob: {},
      transportadoraCif: {},
      quantidadeTotalItens: 0,
      valorTotalPedido: 0,
      listarTabelaItens: [],
    },
  }),

  actions: {
    async clearPedidoData({ commit }) {
      commit('SET_LISTA_TABELA_ITENS', []);
      commit('CLEAR_JSON_TELA_NOVA_PEDIDO');

      commit('SET_QUANTIDADE_TOTAL_ITENS', 0);
      commit('SET_VALOR_TOTAL_PEDIDO', 0);
    },
    async itensMarcaPedido({ commit, state }, precoId) {
      try {
        commit('SET_IS_LOADING_MARCA', true);
        commit('CLEAR_ES_MARCAS');
        const response = await new SLS_pedidosVendasService().itensMarcaPedido(precoId);
        commit('SET_ES_MARCAS', response.data);
        response.data.length > 0 ? state.setExisteMarca = true : state.setExisteMarca = false;
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('SET_IS_LOADING_MARCA', false);
      }
    },
    async itensCategoriaPedido({ commit, state }, cod_marca) {
      try {
        commit('SET_IS_LOADING_CATEGORIA', true);
        commit('CLEAR_ES_CATEGORIAS');
        const response = await new SLS_pedidosVendasService().itensCategoriaPedido(cod_marca);
        commit('SET_ES_CATEGORIAS', response.data);
        response.data.length > 0 ? state.setExisteCategoria = true : state.setExisteCategoria = false;
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('SET_IS_LOADING_CATEGORIA', false);
      }
    },
    async itensReferenciaPedido({ commit, state }, data) {
      try {
        console.log('comecou achar referencia');
        commit('SET_IS_LOADING_REFERENCIA', true);
        commit('CLEAR_ES_REFERENCIAS');
        const response = await new SLS_pedidosVendasService().itensReferenciaPedido(data.selected_cod_marca, data.selected_categoria);
        commit('SET_ES_REFERENCIAS', response.data);
        response.data.length > 0 ? state.setExisteReferencia = true : state.setExisteReferencia = false;
      } catch (error) {
        console.error('error', error);
      } finally {
        console.log('acabbou achar referencia');
        commit('SET_IS_LOADING_REFERENCIA', false);
      }
    },
    async itensEmbalagemPedido({ commit, state }, data) {
      try {
        commit('SET_IS_LOADING_EMBALAGEM', true);
        commit('CLEAR_ES_EMBALAGENS');
        const response = await new SLS_pedidosVendasService().itensEmbalagemPedido(data.selected_referencia, data.precoId);
        commit('SET_ES_EMBALAGENS', response.data);
        response.data.length > 0 ? state.setExisteEmbalagem = true : state.setExisteEmbalagem = false;
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('SET_IS_LOADING_EMBALAGEM', false);
      }
    },
    // async detalhesPedidoStored({ commit, state }, payload) {
    //     try {
    //         const { familiaComercialId, precoId, codMarca, codCateg } = payload;
    //         commit('SET_IS_LOADING_EMBALAGEM', true);
    //         commit('SET_IS_LOADING_IMAGENS', true);
    //         commit('CLEAR_ES_EMBALAGENS');
    //         const response = await new SLS_pedidosVendasService().detalhesPedidoStored(
    //             familiaComercialId,
    //             precoId,
    //             codMarca,
    //             codCateg
    //         );
    //         commit('SET_ES_EMBALAGENS', response.data);
    //         response.data.length > 0 ? state.setExisteEmbalagem = true : state.setExisteEmbalagem = false;
    //         return response
    //     } catch (error) {
    //         console.error('Erro na action detalhesPedidoStored:', error);
    //     } finally {
    //         commit('SET_IS_LOADING_EMBALAGEM', false);
    //         commit('SET_IS_LOADING_IMAGENS', false);
    //     }
    // },
    async detalhesPedidoStored({ commit, state }, payload) {
      try {
        commit('SET_IS_LOADING_EMBALAGEM', true);
        commit('SET_IS_LOADING_IMAGENS', true);
        commit('SET_IS_LOADING_REFERENCIA_RESTANTE', true);
        // commit('CLEAR_ES_EMBALAGENS');
        const {
          familiaComercialId, precoId, codMarca, codCateg,
        } = payload;
        const response = await new SLS_pedidosVendasService().detalhesPedidoStored(
          familiaComercialId,
          precoId,
          codMarca,
          codCateg,
        );
        // commit('SET_ES_EMBALAGENS', response.data);
        // response.data.length > 0 ? state.setExisteEmbalagem = true : state.setExisteEmbalagem = false;
        return response;
      } catch (error) {
        console.error('Erro na action detalhesPedidoStored:', error);
        throw error;
      } finally {
        commit('SET_IS_LOADING_EMBALAGEM', false);
        commit('SET_IS_LOADING_IMAGENS', false);
        commit('SET_IS_LOADING_REFERENCIA_RESTANTE', false);
      }
    },
    async armazenarGradeItem({ commit }, { referencia, embalagem, data }) {
      commit('SET_GRADE_ITEM', { referencia, embalagem, data });
    },
    async clearCreatePedido({ commit, state }) {
      commit('SET_CAPA_PEDIDO', {
        representanteid: '',
        representantenome: '',
        estabelecimentoid: '',
        condicaopagamentoid: '',
        estabelecimentorazaosocial: '',
        clienteiderp: '',
        cliente_nome: '',
        clienteisentoie: '',
        clientenomeabreviado: '',
        naturezaoperacaoid: '',
        condicaopagamentodescricao: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        nr_oc: '',
        prioridade_pedido: '',
        observacoes: '',
      });
      commit('SET_ENDERECO_ENTREGA', {
        clienteid: '',
        tipoenderecoid: '',
        clienteenderecoseq: '',
        clienteiderp: '',
        clienteenderecocep: '',
        clienteendereco: '',
        paisid: '',
        ufid: '',
        clienteenderecoobservacoes: '',
        clienteenderecocidade: '',
        clienteenderecobairro: '',
        clienteiderpenderecoentrega: '',
        clienteenderecoie: '',
        pais_nome: '',
        tipoEnderecoDescricao: '',
        dataPrevistaEntrega: '',
      });
      state.setFormData.dataItensPedido = {
        item_id: '',
        item_name: '',
        item_price: '',
        item_descricao: '',
        item_caracteristicas: '',
        item_composisao: '',
        item_indicacoes: '',
        item_img_princial: '',
        item_marca: '',
        cod_marca: '',
        referencia: '',
        gradeItem: [],
        imagens: [],
      };
      commit('LIMPAR_TABELA_ITENS');
      state.setEsMarcas = [{
        value: null,
        text: 'Selecione uma marca',
        disabled: true,
      }];
      state.setEsCategorias = [{
        value: null,
        text: 'Selecione uma categoria',
        disabled: true,
      }];
      state.setEsReferencias = [
        {
          value: null,
          text: 'Selecione uma referência',
          disabled: true,
        },
      ];
      state.setEsEmbalagens = [
        {
          value: null,
          text: 'Selecione uma embalagem',
          disabled: true,
        },
      ];
    },
    async clearModalItens({ commit, state }) {
      state.setEsMarcas = [{
        value: null,
        text: 'Selecione uma marca',
        disabled: true,
      }];
      state.setEsCategorias = [{
        value: null,
        text: 'Selecione uma categoria',
        disabled: true,
      }];
      state.setEsReferencias = [
        {
          value: null,
          text: 'Selecione uma referência',
          disabled: true,
        },
      ];
      state.setEsEmbalagens = [
        {
          value: null,
          text: 'Selecione uma embalagem',
          disabled: true,
        },
      ];
      state.setFormData.dataItensPedido = {
        item_id: '',
        item_name: '',
        item_price: '',
        item_descricao: '',
        item_caracteristicas: '',
        item_composisao: '',
        item_indicacoes: '',
        item_img_princial: '',
        item_marca: '',
        cod_marca: '',
        referencia: '',
        gradeItem: [],
        imagens: [],
      };
    },
    resetDataCapaPedido({ commit }) {
      commit('SET_CAPA_PEDIDO', {
        representanteid: '',
        representantenome: '',
        estabelecimentoid: '',
        condicaopagamentoid: '',
        estabelecimentorazaosocial: '',
        clienteiderp: '',
        cliente_nome: '',
        clienteisentoie: '',
        clientenomeabreviado: '',
        naturezaoperacaoid: '',
        condicaopagamentodescricao: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        nr_oc: '',
        prioridade_pedido: '',
        observacoes: '',
      });
    },
    resetDataCapaPedidoCliente({ commit }) {
      commit('SET_ENDERECO_ENTREGA', {
        clienteid: '',
        tipoenderecoid: '',
        clienteenderecoseq: '',
        clienteiderp: '',
        clienteenderecocep: '',
        clienteendereco: '',
        paisid: '',
        ufid: '',
        clienteenderecoobservacoes: '',
        clienteenderecocidade: '',
        clienteenderecobairro: '',
        clienteiderpenderecoentrega: '',
        clienteenderecoie: '',
        pais_nome: '',
        tipoEnderecoDescricao: '',
        dataPrevistaEntrega: '',
      });
    },
    async itensdetalhes({ commit, state }, data) {
      try {
        commit('SET_IS_LOADING_IMAGENS', true);
        const response = await new SLS_pedidosVendasService().getDetalhesItems(data);
        // console.log('response-2', response);
        commit('SET_DETALHES_ITEM', response);
        return response;
      } catch (error) {
        this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING_IMAGENS', false);
      }
    },
    async setListTabelaItens({ commit, state }, data) {
      if (Array.isArray(data)) {
        commit('SET_LISTA_TABELA_ITENS', data);
        return;
      }

      commit('SET_TABELA_ITENS', data);
    },
    async setIsLoadingReferencia({ commit, state }, data) {
      commit('SET_IS_LOADING_REFERENCIA', data);
    },
    async setIsLoadingReferenciaRestante({ commit, state }, data) {
      commit('SET_IS_LOADING_REFERENCIA_RESTANTE', data);
    },
    async removeItemListTabelaItens({ commit, state }, data) {
      state.setFormData.listarTabelaItens.splice(data, 1);
    },
    async exibirItemEditar({ commit, state }, data) {
      try {
        commit('SET_IS_LOADING_CATEGORIA', true);
        commit('CLEAR_ES_CATEGORIAS');
        const response = await new SLS_pedidosVendasService().itensCategoriaPedido(data.item.cod_marca);
        commit('SET_ES_CATEGORIAS', response.data);
        response.data.length > 0 ? state.setExisteCategoria = true : state.setExisteCategoria = false;
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('SET_IS_LOADING_CATEGORIA', false);
      }
      // console.log('precoID', data.item.precoId);
      // console.log('marca', data.item.cod_marca);
      // await this.itensCategoriaPedido({commit, state}, data.item.cod_marca);
      // this.itensReferenciaPedido({commit, state}, {selected_cod_marca: data.item.cod_marca, selected_categoria: data.item.cod_categ});
      // this.itensEmbalagemPedido({commit, state}, {selected_referencia: data.item.cod_referencia, precoId: data.item.precoId});
    },
    async buscaCorGradeItens({ commit, state, dispatch }, data) {
      try {
        for (const item of data) {
          const existItemGrade = state.setFormData.dataItensPedido.gradeItem.find((grade) => grade.cdn_cor === item.cdncor);
          if (existItemGrade) {
            existItemGrade[item.desc_tamanho].quantidade = item.pedidoItemQuantidade;
          }
        }
        commit('SET_FORM_DATA_ITENS_PEDIDO_GRADE_ITEM', state.setFormData.dataItensPedido.gradeItem);
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('SET_IS_LOADING', false);
      }
    },
    async set_tabela_itens_pic({ commit, state }, data) {
      commit('SET_TABELA_ITENS_PIC', data);
    },
    async setjsonTelaNovaPedido({ commit, state }, data) {
      commit('SET_IS_JSON_TELA_NOVA_PEDIDO', data);
    },
    async clearjsonTelaNovaPedido({ commit, state }) {
      commit('CLEAR_JSON_TELA_NOVA_PEDIDO');
    },
    async buscarReferenciaPorCodigo({ commit, state }, { codReferencia, tabelaPrecoId }) {
      try {
        commit('SET_IS_LOADING_REFERENCIA', true);
        commit('CLEAR_ES_REFERENCIAS');
        const response = await new SLS_pedidosVendasService().buscarReferenciaPorCodigo(codReferencia, tabelaPrecoId);

        if (response.data && response.data.length > 0) {
          if (response.data.length === 1) {
            const referencia = response.data[0];

            state.setEsMarcas = [
              { value: null, text: 'Selecione uma marca', disabled: true },
              { value: referencia.cod_marca, text: referencia.des_marca },
            ];

            state.setEsCategorias = [
              { value: null, text: 'Selecione uma categoria', disabled: true },
              { value: referencia.cod_categ, text: referencia.categoria_descricao },
            ];
          }

          commit('SET_ES_REFERENCIAS', response.data);
          state.setExisteReferencia = true;

          return {
            success: true,
            data: response.data,
          };
        }
        state.setExisteReferencia = false;
        return {
          success: false,
          message: 'Referência não encontrada',
        };
      } catch (error) {
        console.error('error', error);
        return {
          success: false,
          message: 'Erro ao buscar referência',
        };
      } finally {
        commit('SET_IS_LOADING_REFERENCIA', false);
      }
    },
  },
  mutations: {
    SET_LISTA_TABELA_ITENS(state, items) {
      state.setFormData.listarTabelaItens = items;
    },
    SET_QUANTIDADE_TOTAL_ITENS(state, qty) {
      state.setFormData.quantidadeTotalItens = qty;
    },
    SET_VALOR_TOTAL_PEDIDO(state, value) {
      state.setFormData.valorTotalPedido = value;
    },
    CLEAR_JSON_TELA_NOVA_PEDIDO(state) {
      state.jsonTelaNovaPedido = [];
    },
    UPDATE_TABELA_ITEM(state, { index, item }) {
      if (!state.setFormData || !state.setFormData.listarTabelaItens) {
        console.error('listarTabelaItens é undefined');
        return;
      }

      if (index === undefined || index < 0 || index >= state.setFormData.listarTabelaItens.length) {
        console.error(`Índice de item inválido: ${index}`);
        return;
      }

      Vue.set(state.setFormData.listarTabelaItens, index, JSON.parse(JSON.stringify(item)));

      state.setFormData.quantidadeTotalItens = state.setFormData.listarTabelaItens.reduce(
        (sum, i) => sum + parseInt(i.Qtde || 0), 0,
      );

      state.setFormData.valorTotalPedido = state.setFormData.listarTabelaItens.reduce((sum, i) => {
        if (i.itens && i.itens.length > 0) {
          return sum + i.itens.reduce((subTotal, subItem) => subTotal + parseFloat(subItem.valorTotalComImposto || subItem.valorTotal || 0), 0);
        }
        return sum + parseFloat(i.ValorTotalComImposto || i.ValorTotal || 0);
      }, 0);

      console.log('Totais recalculados com impostos:', {
        quantidadeTotalItens: state.setFormData.quantidadeTotalItens,
        valorTotalPedido: state.setFormData.valorTotalPedido,
      });
    },
    SET_FORM_DATA(state, payload) {
      if (payload.dataCapaPedido) {
        state.setFormData.dataCapaPedido = {
          ...state.setFormData.dataCapaPedido,
          ...payload.dataCapaPedido,
        };
      }
    },
    SET_GRADE_ITEM(state, { referencia, embalagem, data }) {
      if (!state.gradesItens) state.gradesItens = {};
      if (!state.gradesItens[referencia]) state.gradesItens[referencia] = {};

      state.gradesItens[referencia][embalagem] = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },
    SET_IS_JSON_TELA_NOVA_PEDIDO(state, data) {
      // console.log('Mutação chamada com data:', data);
      state.jsonTelaNovaPedido = [...state.jsonTelaNovaPedido, data];
    },
    CLEAR_JSON_TELA_NOVA_PEDIDO(state) {
      state.jsonTelaNovaPedido = [];
    },
    SET_ES_MARCAS(state, data) {
      state.setEsMarcas.unshift({
        value: null,
        text: 'Selecione uma marca',
        disabled: true,
      });

      data.forEach((item) => {
        state.setEsMarcas.push({
          value: item.cod_marca,
          text: item.des_marca,
        });
      });
    },
    SET_ES_CATEGORIAS(state, data) {
      state.setEsCategorias.unshift({
        value: null,
        text: 'Selecione uma categoria',
        disabled: true,
      });

      data.forEach((item) => {
        state.setEsCategorias.push({
          value: item.cod_categ,
          text: item.descricao,
        });
      });
    },
    SET_ES_REFERENCIAS(state, data) {
      state.setEsReferencias.unshift({
        value: null,
        text: 'Selecione uma referência',
        disabled: true,
      });

      data.forEach((item) => {
        state.setEsReferencias.push({
          value: {
            codReferencia: item.CodReferencia,
            referencia: item.Referencia,
          },
          text: `${item.CodReferencia} - ${item.Referencia}`,
        });
      });
    },
    SET_ES_EMBALAGENS(state, data) {
      state.setEsEmbalagens.unshift({
        value: null,
        text: 'Selecione uma embalagem',
        disabled: true,
      });

      data.forEach((item) => {
        state.setEsEmbalagens.push({
          value: {
            cdn_embalagem: item.cdn_embalagem,
            des_embalag: item.des_embalag,
          },
          text: item.des_embalag,
        });
      });
    },

    CLEAR_ES_MARCAS(state) {
      state.setEsMarcas = [];
    },
    CLEAR_ES_CATEGORIAS(state) {
      state.setEsCategorias = [];
    },
    CLEAR_ES_REFERENCIAS(state) {
      state.setEsReferencias = [];
    },
    CLEAR_ES_EMBALAGENS(state) {
      state.setEsEmbalagens = [];
    },

    SET_IS_LOADING_CATEGORIA(state, data) {
      state.setIsLoadingCategoria = data;
    },
    SET_IS_LOADING_REFERENCIA(state, data) {
      state.setIsLoadingReferencia = data;
    },
    SET_IS_LOADING_REFERENCIA_RESTANTE(state, data) {
      state.setIsLoadingReferenciaRestante = data;
    },
    SET_IS_LOADING_EMBALAGEM(state, data) {
      state.setIsLoadingEmbalagem = data;
    },
    SET_IS_LOADING_MARCA(state, data) {
      state.setIsLoadingMarca = data;
    },
    SET_IS_LOADING_CAPA_PEDIDO(state, data) {
      state.setIsLoadingCapaPedido = data;
    },
    SET_IS_LOADING_IFO_CLIENTE(state, data) {
      state.setIsLoadingCliente = data;
    },
    SET_IS_LOADING_IMAGENS(state, data) {
      state.setIsLoadingimagens = data;
    },

    SET_CAPA_PEDIDO(state, data) {
      state.setFormData.dataCapaPedido = data;
    },
    SET_IFO_REPRESENTANTE(state, data) {
      state.setFormData.dataCapaPedido.representanteid = data.representanteid;
      state.setFormData.dataCapaPedido.representantenome = data.representantenome;
    },
    SET_IFO_CONDPAGTO(state, data) {
      state.setFormData.dataCapaPedido.condicaopagamentoid = data.condicaopagamentoid;
      state.setFormData.dataCapaPedido.condicaopagamentodescricao = data.condicaopagamentodescricao;
    },
    SET_IFO_CLIENTE(state, data) {
      state.setFormData.dataCapaPedido.clienteiderp = data.cliente.clienteiderp;
      state.setFormData.dataCapaPedido.cliente_nome = data.cliente.clienterazaosocial;
      state.setFormData.dataCapaPedido.clientenomeabreviado = data.cliente.clientenomeabreviado;
      state.setFormData.dataCapaPedido.clienteisentoie = data.cliente.clienteisentoie;
      state.setFormData.dataCapaPedido.condicaopagamentoid = data.condicaoPagamento.condicaopagamentoid;
      state.setFormData.dataCapaPedido.condicaopagamentodescricao = data.condicaoPagamento.condicaopagamentodescricao;
      state.setFormData.dataCapaPedido.tabelaprecoid = data.tabelaPreco.tabelapreco_id;
      state.setFormData.dataCapaPedido.tabelapreco_descricao = data.tabelaPreco.tabelapreco_descricao;
      state.setFormData.dataCapaPedido.estabelecimentorazaosocial = data.estabelecimento.estabelecimentorazaosocial;
      state.setFormData.dataCapaPedido.estabelecimentoid = data.estabelecimento.estabelecimentoid;
      state.setFormData.transportadoraCif = data.transportadoraCIF;
      state.setFormData.transportadoraFob = data.transportadoraFob;
      state.setFormData.enderecoEntrega.clienteid = data.enderecoEntrega.clienteid;
      state.setFormData.dataCapaPedido.naturezaoperacaodescricao = data.naturezaOperacao?.naturezaoperacaodescricao ?? '';
      state.setFormData.dataCapaPedido.naturezaoperacaoid = data.naturezaOperacao?.naturezaoperacaoid ?? '';
      state.setFormData.dataCapaPedido.canalvendaid = data.canalVenda?.canal_venda_id ?? '';
      state.setFormData.dataCapaPedido.canal_venda_descricao = data.canalVenda?.canal_venda_descricao ?? '';
      state.setFormData.dataCapaPedido.prioridade_pedido = data.prioridadesPedido;
      state.setFormData.enderecoEntrega.tipoenderecoid = data.enderecoEntrega.tipoenderecoid;
      state.setFormData.enderecoEntrega.clienteenderecoseq = data.enderecoEntrega.clienteenderecoseq;
      state.setFormData.enderecoEntrega.clienteiderp = data.enderecoEntrega.clienteiderp;
      state.setFormData.enderecoEntrega.clienteendereco = data.enderecoEntrega.clienteendereco;
      state.setFormData.enderecoEntrega.clienteenderecocep = data.enderecoEntrega.clienteenderecocep;
      state.setFormData.enderecoEntrega.paisid = data.enderecoEntrega.paisid;
      state.setFormData.enderecoEntrega.ufid = data.enderecoEntrega.ufid;
      state.setFormData.enderecoEntrega.clienteenderecoobservacoes = data.enderecoEntrega.clienteenderecoobservacoes;
      state.setFormData.enderecoEntrega.clienteenderecocidade = data.enderecoEntrega.clienteenderecocidade;
      state.setFormData.enderecoEntrega.clienteenderecobairro = data.enderecoEntrega.clienteenderecobairro;
      state.setFormData.enderecoEntrega.clienteiderpenderecoentrega = data.enderecoEntrega.clienteiderpenderecoentrega;
      state.setFormData.enderecoEntrega.clienteenderecoie = data.enderecoEntrega.clienteenderecoie;
      state.setFormData.enderecoEntrega.pais_nome = data.enderecoEntrega.pais_nome;
      state.setFormData.enderecoEntrega.tipoEnderecoDescricao = data.enderecoEntrega.tipoEnderecoDescricao;
      state.setFormData.enderecoEntrega.dataPrevistaEntrega = data.dataPrevistaEntrega;
      // state.setFormData.dataCapaPedido.canalvendaid = data.canalVenda.canal_venda_id;
      state.setFormData.dataCapaPedido.tipopedidoid = data.tipoPedido?.tipopedidoid ?? '';
      state.setOptionsTipoPedidoCliente = data.optionsTipoPedidoCliente;
    },
    SET_ENDERECO_ENTREGA(state, enderecoEntrega) {
      state.setFormData.enderecoEntrega = {
        ...state.setFormData.enderecoEntrega,
        ...enderecoEntrega,
      };
    },
    SET_DETALHES_ITEM(state, data) {
      state.setFormData.dataItensPedido.item_id = data.item_id;
      state.setFormData.dataItensPedido.item_name = data.item_name;
      state.setFormData.dataItensPedido.item_price = data.item_price;
      state.setFormData.dataItensPedido.item_descricao = data.item_descricao;
      state.setFormData.dataItensPedido.item_caracteristicas = data.item_caracteristicas;
      state.setFormData.dataItensPedido.item_composisao = data.item_composisao;
      state.setFormData.dataItensPedido.item_indicacoes = data.item_indicacoes;
      state.setFormData.dataItensPedido.item_img_princial = data.item_img_princial;
      state.setFormData.dataItensPedido.item_marca = data.item_marca;
      state.setFormData.dataItensPedido.cod_marca = data.cod_marca;
      state.setFormData.dataItensPedido.referencia = data.referencia;
      state.setFormData.dataItensPedido.gradeItem = data.gradeItem;
      state.setFormData.dataItensPedido.imagens = data.imagens;
    },

    SET_IMAGEM_PRINCIPAL(state, data) {
      state.setFormData.dataItensPedido.item_img_princial = data;
    },
    LIMPAR_TABELA_ITENS(state) {
      state.setFormData.listarTabelaItens = [];
    },
    UPDATE_TABELA_SUBITEM(state, { itemIndex, subItemIndex, subItem }) {
      if (!state.setFormData || !state.setFormData.listarTabelaItens) {
        console.error('listarTabelaItens é undefined');
        return;
      }

      if (itemIndex === undefined || itemIndex < 0 || itemIndex >= state.setFormData.listarTabelaItens.length) {
        console.error(`Índice de item inválido: ${itemIndex}`);
        return;
      }

      const item = state.setFormData.listarTabelaItens[itemIndex];

      if (!item.itens || !Array.isArray(item.itens)) {
        console.error(`itens não é um array válido para o item no índice ${itemIndex}`);
        return;
      }

      if (subItemIndex === undefined || subItemIndex < 0 || subItemIndex >= item.itens.length) {
        console.error(`Índice de subitem inválido: ${subItemIndex}`);
        return;
      }

      state.setFormData.listarTabelaItens[itemIndex].itens[subItemIndex] = subItem;
    },
    SET_TABELA_ITENS(state, data) {
      console.log('data', data);

      const referenciaIndex = state.setFormData.listarTabelaItens.findIndex((item) => item.referencia === data.referencia);

      if (referenciaIndex !== -1) {
        const exactMatchIndex = state.setFormData.listarTabelaItens.findIndex((item) => item.referencia === data.referencia
                    && item.CodReferencia === data.CodReferencia);

        if (exactMatchIndex !== -1) {
          console.log('Atualizando item existente');
          const exist = state.setFormData.listarTabelaItens[exactMatchIndex];

          exist.Qtde = data.Qtde;
          exist.ValorTotal = data.ValorTotal;
          exist.itens = [...data.itens];
        } else {
          state.setFormData.listarTabelaItens.push({
            ...data,
            itens: [...data.itens],
          });
        }
      } else {
        state.setFormData.listarTabelaItens.push({
          ...data,
          itens: [...data.itens],
        });
      }
    },
    SET_TABELA_ITENS_PIC(state, data) {
      state.setFormData.listarTabelaItens = data;
    },
    SET_EMBALEGEM_FORM(state, payload) {
      state.setFormData.dataCapaPedido.cdn_embalagem = payload.cdn_embalagem;
      state.setFormData.dataCapaPedido.des_embalag = payload.des_embalag;
    },

    SET_FORM_DATA_ITENS_PEDIDO_GRADE_ITEM(state, payload) {
      state.setFormData.dataItensPedido.gradeItem = payload;
    },

  },

  getters: {
    getEsMarcas: (state) => state.setEsMarcas,
    getEsCategorias: (state) => state.setEsCategorias,
    getEsReferencias: (state) => state.setEsReferencias,
    getEsEmbalagens: (state) => state.setEsEmbalagens,
    getIsLoading: (state) => state.setIsLoading,
    getIsLoadingCategoria: (state) => state.setIsLoadingCategoria,
    getIsLoadingReferencia: (state) => state.setIsLoadingReferencia,
    getIsLoadingReferenciaRestante: (state) => state.setIsLoadingReferenciaRestante,
    getIsLoadingEmbalagem: (state) => state.setIsLoadingEmbalagem,
    getIsLoadingMarca: (state) => state.setIsLoadingMarca,
    getIsLoadingPrecoItens: (state) => state.setIsLoadingPrecoItens,
    getExisteMarca: (state) => state.setExisteMarca,
    getExisteCategoria: (state) => state.setExisteCategoria,
    getExisteReferencia: (state) => state.setExisteReferencia,
    getExisteEmbalagem: (state) => state.setExisteEmbalagem,
    getFormData: (state) => state.setFormData,
    getIsLoadingCapaPedido: (state) => state.setIsLoadingCapaPedido,
    getIsLoadingCliente: (state) => state.setIsLoadingCliente,
    getlistarTabelaItens: (state) => state.setFormData.listarTabelaItens,
    getjsonTelaNovaPedido: (state) => state.jsonTelaNovaPedido,
    getQuantidadeTotalItens: (state) => state.quantidadeTotalItens,
    getValorTotalPedido: (state) => state.valorTotalPedido,
    getTotalPedido: (state) => {
      const total = state.setFormData.listarTabelaItens.reduce((acc, item) => {
        const itemTotalComImposto = item.itens ? item.itens.reduce((subTotal, subItem) => subTotal + parseFloat(subItem.valorTotalComImposto || subItem.valorTotal || 0), 0) : 0;

        console.log(`Item ${item.CodReferencia || 'sem código'}: Valor com imposto: ${itemTotalComImposto}`);
        return acc + itemTotalComImposto;
      }, 0);

      // console.log('Total com impostos calculado pelo getter:', total);
      return total;
    },
  },

};
